"use client";
import React, { useContext, useEffect } from 'react';
import { createContext, useState } from 'react';
import generateCustomStyles from '../utils/styles';
import useWebSocket from 'react-use-websocket';
import { BASE_URL } from '../service';
import { remapChatHistory } from '../utils';
import { UserManagementContext } from './userManagementContext';

type TProps = {
  config: any;
  children: any
}

type TAppState = {
  widgetConfig: any;
  chatHistory: any[];
  sendMessage: (val: any) => void;
  getWebSocket: () => any;
}

const getSocketUrl = (projectId: string, userToken: string | null) => {
  if (!userToken) {
    return null;
  }
  return `${BASE_URL.replace('https', 'wss')}/sales/isi-pilot/chats/${projectId}/stream?chatSessionId=${userToken}`;
};


export const AppContext = createContext<TAppState>({
  widgetConfig: {},
  chatHistory: [],
  sendMessage: (val: any) => { console.log('method is not init')},
  getWebSocket: () => { console.log('method is not init')},
});

export const AppProvider = ({config, children}: TProps) => {
  if(!config.projectId) {
    console.error("Please provide project Id in your config")
    return
  }
  const {userToken, waiting} = useContext(UserManagementContext);
  const [chatHistory, setChatHistory] = useState([]);
  const [widgetConfig, setWidgetConfig] = useState(config);
  const render = widgetConfig.render;
  const SOCKET_URL = getSocketUrl(widgetConfig.projectId, userToken);

  const { sendMessage, getWebSocket, readyState } = useWebSocket(
    SOCKET_URL, {
      shouldReconnect: (closeEvent) => true,
      onMessage: (message) => {
        const response = JSON.parse(message.data);
        console.log('response', response);
  
        if (response.event === 'connected') {
          const remapped = remapChatHistory(response);
          setChatHistory(remapped || []);
        }
      }
    },
    Boolean(SOCKET_URL)
  );
  

  console.log('userToken', userToken, 'waiting', waiting, 'readyState', readyState);
    
  useEffect(() => {
    setWidgetConfig(config)
  }, [config])

  const state = {
    widgetConfig,
    chatHistory,
    sendMessage, 
    getWebSocket
  };

  return (
    <AppContext.Provider 
      value={state}
    >
      <style>
        {
          generateCustomStyles({
            ...(config.customStyles || {}), 
            viewMode: !!render.viewMode
          })
        }
      </style>
      {children}
    </AppContext.Provider>
  );
}

export default AppProvider;
